<template>
  <div class="cm-contacts-list-container">
    <slot name="header" />
    <div class="cm-contacts-list" :style="{height: listheight}">
      
      <transition name="fade">
          <div v-if="loading > 0" class="cm-loader">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
      </transition>

      <slot name="listheader" />

      <p v-if="!items.length && !loading" class="no-contacts-text">{{emptytext}}</p>
      <div v-for="contact in sortedList" :key="contact.id">
        <div :class="['cm-contact', {highlight: highlight.includes(contact.id)}, {last: highlight.length && highlight[highlight.length-1].id == contact.id}]" @click.ctrl="shiftClickContact(contact)" @click.exact="clickContact(contact)">
          <p><v-icon :color="contact.type == 'Internal' ? 'blue' :'red'">{{contact.type == 'Internal' ? 'mdi-account-arrow-left' :'mdi-account-arrow-right'}}</v-icon><span>{{contact.firstName}} {{contact.lastName}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    highlight: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    emptytext: {
      type: String,
      default: () => 'No contacts found.'
    },
    listheight: {
      type: String,
      default: () => '400px'
    }
  },

  computed: {
    sortedList () {
      return this.items.filter(i => i)
    }
  },

  methods: {
    clickContact (contact) {
      this.$emit('selected', contact)
    },

    shiftClickContact (contact) {
      this.$emit('ctrlselected', contact)
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-contacts-list-container {
  box-sizing: content-box;
  padding: 10px 20px;

  .cm-contacts-list {
    background: #f5f5f5;
    box-shadow: 3px 3px 3px rgba(0,0,0,0.2);
    overflow-y: scroll;
    width: 300px;
    position: relative;

    // displayed only when co contacts are available in the list
    .no-contacts-text {
      width: 100%;
      text-align: center;
      padding: 20px 0;
      color: #2f2f2f;
      letter-spacing: 0.07em;
    }

    .cm-contact {
      padding: 5px 10px;
      transition: all .2s;

      // contact item
      p {
        font-weight: bold;
        color: #2f2f2f;
        user-select: none;

        // name text
        span {
          display: inline-block;
          margin-left: 10px;
           user-select: none;
        }
      }
      
      &:hover {
        cursor: pointer;
        background: #83ffd8;
      }

      &.highlight {
        span {
          color: white;
        } 
  
        background: rgb(54, 211, 161);
      }

      &.last {
        background: blue;
      }

      p {
        margin: 0;
      }
    }

    &::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #ddd;
    }

    &::-webkit-scrollbar-thumb {
      background: #aaa;
      transition: all .2s;

      &:hover {
        background: #999;
      }
    }
  }
}


 // spinner div
.cm-loader {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: rgba(255,255,255, 0.7);
}
</style>